<template>
    <el-popover placement="bottom" trigger="hover">
        <span slot="reference" class="el-icon-setting tools_class"></span>
        <el-checkbox-group v-model="selData" :min="1" @change="handleCheckedHeadTitlesChange">
            <div style="display:flex; flex-direction: column;">
                <el-checkbox v-for="(item) in data" :label="item.label" :key="item.prop"
                    :disabled="item.label == '课程标题' ? true : false">{{ item.label }}</el-checkbox>
            </div>
        </el-checkbox-group>
    </el-popover>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: [],
        },
        selData:{
            type: Array,
            default: [],
        }
    },
    data() {
        return {
        }
    },
    methods:{
        handleCheckedHeadTitlesChange(e){
            this.$emit("titlesChange",e);
        }

    }
}
</script>

<style>
.tools_class {
    font-size: 20px;
    position: absolute;
    top: 50%;
    transform: translateX(-50%);
    right: 0;
    font-weight: normal;
    color: #606266;
}
</style>